import { render, staticRenderFns } from "./MNSTR.vue?vue&type=template&id=4a5958b8&"
import script from "./MNSTR.vue?vue&type=script&lang=js&"
export * from "./MNSTR.vue?vue&type=script&lang=js&"
import style0 from "./MNSTR.vue?vue&type=style&index=0&id=4a5958b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports